import React from 'react';

import { useQuery } from '@apollo/client/react';
import { Flex, Text } from '@opendoor/bricks/core';
import { IAddressInputAddress } from '@opendoor/cinderblocks/growth/AddressInput/AddressInput';

import { publicClient } from '../config/apolloClients';
import {
  GET_PRODUCT_ELIGIBILITY,
  IGetProductEligibility,
  IGetProductEligibilityVariables,
} from '../graphql/queries/GetProductEligibility';
import { dollarsToCurrencyString } from '../helpers/formatUtils';

interface IAddressProps {
  address?: IAddressInputAddress;
}

const ProductEligibilityText: React.FC<IAddressProps> = ({ address }) => {
  const { data, loading } = useQuery<IGetProductEligibility, IGetProductEligibilityVariables>(
    GET_PRODUCT_ELIGIBILITY,
    {
      skip: !address,
      variables: {
        addressInput: {
          street1: address ? address.street1 : '',
          city: address ? address.city : '',
          state: address ? address.state : '',
          postalCode: address ? address.postal_code : '',
        },
      },
      client: publicClient,
    },
  );

  if (loading) {
    return null;
  }
  if (!data) {
    return null;
  }

  if (data.address.products.homeSell[0].isEligible) {
    const upper =
      data.address.products.homeSell[0].valueEstimate &&
      dollarsToCurrencyString(data.address.products.homeSell[0].valueEstimate.upper);
    const lower =
      data.address.products.homeSell[0].valueEstimate &&
      dollarsToCurrencyString(data.address.products.homeSell[0].valueEstimate.lower);
    return (
      <Flex flexDirection="column" mb={7}>
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <Text fontSize="s1" lineHeight="s0" mt={7}>
          Good news — this home may qualify for an Opendoor offer!
        </Text>
        {(upper && lower && (
          // eslint-disable-next-line react/jsx-pascal-case
          <Text fontSize="s1" lineHeight="s0" mt={7}>
            Home value estimate: <strong>{lower}</strong> - <strong>{upper}</strong>
          </Text>
        )) || (
          // eslint-disable-next-line react/jsx-pascal-case
          <Text fontSize="s1" lineHeight="s0" mt={7}>
            {
              "We need more information to accurately estimate this home's value. Don't worry! We'll ask you everything we need to know to make a preliminary offer when you request an offer from us for this home."
            }
          </Text>
        )}
      </Flex>
    );
  }

  return (
    // eslint-disable-next-line react/jsx-pascal-case
    <Text fontSize="s1" lineHeight="s0" my={7} width="100%" textAlign="center">
      {data.address.products.homeSell[0].denialExplanation}
    </Text>
  );
};

export default ProductEligibilityText;
